import { ReactNode } from 'react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';
import { useStackedCardWizardContext } from './stacked-card-wizard-context';

interface StepCardProps {
  children: ReactNode;
  isActive: boolean;
  stackIndex: number;
}

export const StepCard = ({ children, isActive, stackIndex }: StepCardProps) => {
  const { secondaryAction } = useStackedCardWizardContext();

  return (
    <motion.div
      initial={{
        opacity: 0,
        scale: 0.8 - stackIndex * 0.05,
        y: -(stackIndex * 8),
        zIndex: theme.zIndex.higher - stackIndex,
      }}
      animate={{
        opacity: 1,
        scale: isActive ? 1 : 1 - stackIndex * 0.03,
        y: -(stackIndex * 10),
        zIndex: theme.zIndex.higher - stackIndex,
      }}
      exit={{
        opacity: 0,
        scale: 0.7,
        x: -100,
        transition: { duration: 0.3 },
      }}
      transition={{
        duration: 0.4,
        ease: 'easeInOut',
      }}
      css={{
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        transformOrigin: 'center top',
        width: '100%',
        gap: theme.spacing(2),
      }}
    >
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          overflow: 'hidden',
          backgroundColor: theme.colors.white,
          borderRadius: theme.borderRadius.medium,
          padding: theme.spacing(4),
          gap: theme.spacing(4),
          boxShadow: isActive ? theme.shadows.heavy : theme.shadows.floating,
          ...(!isActive && { height: 0 }),
        }}
      >
        {children}
      </div>
      {isActive && secondaryAction}
    </motion.div>
  );
};
